import React, { Component } from "react";
import styles from "../../../assets/css/modules/containers/image-hero-container.css";
import { Breakpoints } from "./../../../constants/CssConstants";
import Media from "react-media";
import contentify from "../../../content/Contentify";

export class ImageHeroContainer extends Component {
  // Helper function to check if the prop is a color code
  isColorCode(value) {
    return typeof value === 'string' && value.startsWith('#');
  }

  render() {
    let boxStyles = styles.box;
    if(this.props.Healthsupportline1){
      boxStyles += " " + styles.boxhelp;
    }
    if (this.props.styleOverrides) {
      boxStyles += " " + this.props.styleOverrides.box;
    }

    const isDesktopColor = this.isColorCode(this.props.bgImage);
    const isTabletColor = this.isColorCode(this.props.bgImageTablet);
    const isMobileColor = this.isColorCode(this.props.bgImageMobile);

    return (
      <div className={styles.imageContentHero}>
        <div 
          className={this.props.Healthsupport1==="HealthSupport"?styles.imageHeroBackgroundLg: this.props.HealthsupportSkin==="HealthSupportSkin"?styles.imageHeroBackgroundSkin : this.props.Healthsupportline1==="Healthsupportline"?styles.imageHeroBackgroundSupport :styles.imageHeroBackground}
          style={{
            backgroundColor: isDesktopColor ? this.props.bgImage : 'transparent'
          }}
        >
          {!isDesktopColor && (
            <Media query={Breakpoints.lgUp}>
              <img
                src={this.props.bgImage}
                alt={this.props.bgAlt}
                aria-hidden={this.props.bgAlt ? undefined : true}
              />
            </Media>
          )}
          {!isTabletColor && (
            <Media query={Breakpoints.tablet}>
              <img
                src={this.props.bgImageTablet}
                alt={this.props.bgAlt}
                aria-hidden={this.props.bgAlt ? undefined : true}
              />
            </Media>
          )}
          {!isMobileColor && (
            <Media query={Breakpoints.smDown}>
              <img
                src={this.props.bgImageMobile}
                alt={this.props.bgAlt}
                aria-hidden={this.props.bgAlt ? undefined : true}
              />
            </Media>
          )}
        </div>
        <div className={styles.imageHeroContents}>
          <div className={  this.props.UniqueKey==="GPwhiteBox"? styles.boxWidthGP :
             this.props.UniqueKey==="whiteBox"? this.props.LargeCorporate ? styles.boxlargeWidth : styles.boxWidth  :boxStyles}>{this.props.children}</div>
        </div>
      </div>
    );
  }
}
export default contentify(ImageHeroContainer);
